import apiClient from 'apiClient';
import { Investment as API, InvestmentId as Id } from './Investment';

const remove = async (apiPrefix: string, id: Id): Promise<void> => {
  await apiClient.delete<API>(`${apiPrefix}/${id}`);
};

export default remove;
